import {
  getModule,
  Module,
  VuexModule,
  MutationAction
} from "vuex-module-decorators";
import store from "@/store";
import { SessionStorage } from "@/store/session-storage";
import { SearchItem, SearchResponse } from "@/api/ticket/response";
import { SearchRequest } from "@/api/ticket/request";
import * as TicketAPI from "@/api/ticket";
import { isSuccess } from "@/api/response";

const MODULE_NAME = "ticket/search";

/**
 * デジタルチケット一覧のデコレーター
 */
export class ListItem {
  constructor(private _item: SearchItem) {}
  get id() {
    return this._item.id;
  }
  get title() {
    return this._item.title;
  }
  get typeName() {
    return this._item.typeName;
  }
  get expiration() {
    return this._item.expiration;
  }
  get status() {
    switch (this._item.status) {
      case 0:
        return "非公開";
      case 1:
        return "公開終了";
      case 2:
        return "公開";
      case 3:
        return "期間限定";
      default:
        return "";
    }
  }
  get previewUrl() {
    return this._item.previewUrl;
  }
  get actionFlg() {
    return this._item.actionFlg;
  }
  get writeFlg() {
    return this._item.writeFlg;
  }
  get deleteFlg() {
    return this._item.deleteFlg;
  }
}

/**
 * デジタルチケット一覧検索API（/search-ticket）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Search extends VuexModule {
  // state
  searchRequest: SearchRequest = {} as SearchRequest;
  searchResponse: SearchResponse = {} as SearchResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.searchResponse);
  }

  get getMessage() {
    return this.searchResponse.message;
  }

  get getWriteFlg() {
    if (this.searchResponse.results) {
      return this.searchResponse.results.writeFlg;
    } else {
      return false;
    }
  }

  get getItems() {
    if (this.searchResponse.results) {
      // return this.searchResponse.results.items || [];
      return (this.searchResponse.results.items || []).map(
        value => new ListItem(value)
      );
    } else {
      return [];
    }
  }

  get getTotalCount() {
    if (this.searchResponse.results) {
      return this.searchResponse.results.items.length || 0;
    } else {
      return 0;
    }
  }

  get getSearchRequest() {
    return this.searchRequest;
  }

  // MutationActions
  @MutationAction
  async search(searchRequest: SearchRequest) {
    const searchResponse = await TicketAPI.search(searchRequest);
    SessionStorage.setObject(MODULE_NAME, searchRequest);
    return {
      searchRequest,
      searchResponse
    };
  }

  @MutationAction
  async restore(initial = {} as SearchRequest) {
    const searchRequest = SessionStorage.getObject(
      MODULE_NAME,
      initial
    ) as SearchRequest;
    return {
      searchRequest
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      searchResponse: {} as SearchResponse
    };
  }
}

export default getModule(Search);
